import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'

import {
    createThirdPartyRentalCompany,
    deleteThirdPartyRentalCompany,
    listThirdPartyRentalCompanies,
    updateThirdPartyRentalCompany,
} from './api'
import {rentalAssetKeys} from './query-keys'
import type {
    CreateThirdPartyRentalCompanyInput,
    UpdateThirdPartyRentalCompanyInput,
} from './schemas'

export function useThirdPartyRentalCompanies() {
    return useQuery({
        queryKey: rentalAssetKeys.companies(),
        queryFn: listThirdPartyRentalCompanies,
    })
}

export function useCreateThirdPartyRentalCompany() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: CreateThirdPartyRentalCompanyInput) =>
            createThirdPartyRentalCompany(input),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: rentalAssetKeys.companies()})
        },
    })
}

export function useUpdateThirdPartyRentalCompany() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: ({id, input}: {id: string; input: UpdateThirdPartyRentalCompanyInput}) =>
            updateThirdPartyRentalCompany(id, input),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: rentalAssetKeys.companies()})
            void queryClient.invalidateQueries({queryKey: ['third-party-rental-asset-offerings']})
        },
    })
}

export function useDeleteThirdPartyRentalCompany() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (id: string) => deleteThirdPartyRentalCompany(id),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: rentalAssetKeys.companies()})
        },
    })
}
